import React from 'react'
import ExcelUpload from '../../components/common/excel-upload/excel-upload'

const KapiCikisTeslimTarihi = () => {
    return (
        <>
            <ExcelUpload
                role_name={"kapicikis_teslimtarihi_write"}
                requiredColumnsSase={["sase", "Kapı Çıkış Tarihi", "Teslim Tarihi"]}
                process_type="SOME_INFO"
                ExcelName={"Kapı Çıkış / Teslim Tarihi"}
                Title={"Kapı Çıkış / Teslim Tarihi Yükle"}
                exampleData={[
                    {
                        "sase": "VR3USHNS7RJ793212",
                        "Kapı Çıkış Tarihi": "01.01.2024",
                        "Teslim Tarihi": ""
                    },
                    {
                        "sase": "VR3USHNS7RJ793212",
                        "Kapı Çıkış Tarihi": "",
                        "Teslim Tarihi": "03.01.2024"
                    }
                ]}
            />
        </>
    )
}

export default KapiCikisTeslimTarihi